export const COMMON_FILTERS_COMPONENTS = {
	BLANK: 'blank',

	// Dates
	DATE_RANGE: 'dateRange',
	METRIC: 'metric',

	// Sites
	MARKET: 'country',
	RETAILER: 'retailer',

	// Products
	CATEGORY: 'category',
	BRAND: 'brand',
	SKU_GROUP: 'skuGroup',
	SKU: 'sku',

    //Fav Filters
    FAV_FILTERS: 'favFilters',

    //Show More Button
    SHOW_MORE_FILTERS: 'showMoreFilters',

	//Switches
	PRODUCTS_IN_STOCK: 'productsInStock',
	WITH_SHIPPING_PRICE: 'withShippingPrice'
}